import { PostCommentType } from "../../../objectTypes";
import { PostCommentProps } from "../../../store/types/soc_svc";


export const comment_getEmptyComment = ():PostCommentProps => {
    return {
        post_comment_id: '',
        edited:false,
        activity_post_id: '',
        post_type: 'memo',
        related_comment_id: undefined,
        player_id: '',
        message: '',
        my_reactions: [],
        reaction_details: [],
        status: 'visible',
        create_datetime: '',
        last_update_datetime: '',
        formatted_body: undefined,
        comment_images: [],
        comment_orders: [],
        comment_urls: [],
        url_metadata: [],
        comment_videos:[]
    }
}